import { render, staticRenderFns } from "./StatInspItemNoteForm.vue?vue&type=template&id=8b8a87d8"
import script from "./StatInspItemNoteForm.vue?vue&type=script&lang=js"
export * from "./StatInspItemNoteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports